<div class="dialog">
  <h4 mat-dialog-title>{{ data.title }}</h4>
  <div mat-dialog-actions>
    <button type="button" mat-button (click)="onNoClick()">{{ data.cancelLabel || 'dialog_overview_btn_no' | translate }}</button>
    <button mat-button [mat-dialog-close]="1" color="warn" cdkFocusInitial>{{ data.confirmLabel || 'dialog_overview_btn_yes' | translate }}</button>
  </div>
</div>
